import { Component } from 'react';

import ScrollWrapper from 'components/ScrollWrapper';
import Icon from 'components/Icon';
import { MODAL_BODY_CLASS } from 'components/Login/constants';

import './index.scss';

export default class ModalContainer extends Component {
  componentDidMount() {
    document.addEventListener('keydown', this.handleEscKey);
  }

  componentWillUnmount() {
    document.addEventListener('keydown', this.handleEscKey);
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpened) {
      document.body.classList.add(MODAL_BODY_CLASS);
      return;
    }

    if (prevProps.isOpened) {
      document.body.classList.remove(MODAL_BODY_CLASS);
      this.props.onClose();
    }
  }

  handleEscKey = e => {
    if (e.keyCode === 27) {
      this.handleClose();
    }
  };

  handleClose = () => {
    this.props.onClose();
  };

  handleOutsideClick = e => {
    if (e.target.classList.contains('modal__container')) {
      this.handleClose();
    }
  };

  render() {
    return this.props.isOpened ? (
      <div
        className={cx('modal__container', this.props.className)}
        onClick={this.handleOutsideClick}
      >
        <div className="overlay__btn-close" onClick={this.handleClose}>
          <Icon icon="close-20" />
        </div>
        <div className="modal__popup">
          <ScrollWrapper type="thin" viewClassName="modal__scrollbar">
            {this.props.children}
          </ScrollWrapper>
        </div>
      </div>
    ) : null;
  }
}
